import {
  BrowserRouter,
  Navigate,
  Outlet,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { DashboardLayout } from "./layouts/DashboardLayout";
import { requireAuth } from "./lib/auth";
import { Analytics } from "./pages/Analytics";
import { BrokerAdmin } from "./pages/BrokerAdmin";
import { BrokerUpload } from "./pages/BrokerUpload";
import { InstitutionalAdmin } from "./pages/InstitutionalAdmin";
import { Login } from "./pages/Login";
import { Onboarding } from "./pages/Onboarding";
import { Properties } from "./pages/Properties";
import { PropertyDetail } from "./pages/PropertyDetail";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route element={<RequireAuth />}>
          <Route element={<DashboardLayout />}>
            <Route index element={<Navigate to="/properties" replace />} />
            <Route path="properties" element={<Properties />} />
            <Route path="properties/:id" element={<PropertyDetail />} />
            <Route path="upload" element={<BrokerUpload />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="onboarding" element={<Onboarding />} />
            <Route path="admin/brokers" element={<BrokerAdmin />} />
            <Route path="admin/institutions" element={<InstitutionalAdmin />} />
          </Route>
        </Route>

        <Route path="/broker-upload" element={<Navigate to="/upload" replace />} />
        <Route path="*" element={<Navigate to="/properties" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

function RequireAuth() {
  const location = useLocation();

  if (!requireAuth()) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  return <Outlet />;
}